<template>
  <CoverLayout>
    <div class="buyMemberLayout" slot="content">
      <div class="coverBox">
        <!-- <i class="cover_tl"></i>
      <i class="cover_rb"></i> -->
        <i class="icon_close" @click="handleClose"></i>
        <div class="coverTitle">
          <span>成为年费用户 享受超级权益</span>
        </div>
        <div class="coverSubTitle">
          {{ subTitle }}
        </div>
        <div class="coverContent">
          <div class="options">
            <div class="option">
              <div class="pic prcd1"></div>
              <div>可生成电子证书</div>
              <div>200次</div>
            </div>
            <div class="option">
              <div class="pic prcd2"></div>
              <div>查验他人</div>
              <div>200次</div>
            </div>
            <div class="option">
              <div class="pic prcd3"></div>
              <div>设置查验申请</div>
              <div>应答模板</div>
            </div>
            <div class="option">
              <div class="pic prcd4"></div>
              <div>批量处理</div>
              <div>查验应答</div>
            </div>
          </div>

          <div class="payInfo">
            <div class="qrcode">
              <QRcode
                v-if="code_url"
                :QRlink="code_url"
                :qrwidth="210"
                :qrheight="210"
              />
            </div>

            <div class="payRight">
              <div>
                <div class="scanTip" style="">
                  <i class="ico_wechat"></i>请使用<span class="wechatText"
                    >微信</span
                  >扫码支付
                </div>
                <div>扫码支付完成后，请点击下方按钮，进入下一步。</div>
                <div class="yfText">应付金额：</div>
                <div>
                  <span class="money" v-if="price!==''">￥{{ price / 100 }}</span
                  >/年
                </div>
              </div>
              <div>
                <div class="qrtimeValid">
                  二维码有效时长：<CountDown ref="countDown" />
                </div>
                <div class="refreshTip">
                  如无法支付或者二维码已过期请点击<span
                    class="refresh"
                    @click="handleResetTimer"
                  >
                    刷新</span
                  >
                </div>
              </div>
            </div>
          </div>
          <slot name="btn"></slot>
        </div>
      </div>
    </div>
  </CoverLayout>
</template>

<script>
import QRcode from "@/components/QRcode.vue";
import CountDown from "./CountDown.vue";
import CoverLayout from "./CoverLayout.vue";
import { pay, payInfo } from "@/api/pay";
// import Btn from "./Btn.vue";
export default {
  components: { CoverLayout, QRcode, CountDown },
  props: {
    subTitle: {
      type: String
    },
    socketId: {
      type: String
    },
  },
  data() {
    return {
      type: 0,
      code_url: undefined,
      timerText: "09:59",
      timer: 600,
      price: ''
    };
  },
  created() {
    this.handleRefresh();
  },
  methods: {
    getPayInfo() {
      payInfo().then(res => {
        console.log(res);
        this.price = res.data.d.annualFee;
      });
    },
    handleSelect(type) {
      this.type = type;
      this.price = type === 0 ? 69 : 1;
    },
    handleClose() {
      this.$emit("handleClose");
    },
    handleRefresh() {
      this.getPayInfo();
      pay({
        payType: this.type === 0 ? "ANNUAL_FEE" : this.payType,
        webSocketUserId: this.socketId
      }).then(res => {
        this.code_url = undefined;
        this.code_url = res.data.d.code_url;
      });
    },
    handleResetTimer() {
      this.$refs.countDown.handleReset();
      pay({
        payType: this.type === 0 ? "ANNUAL_FEE" : this.payType,
        webSocketUserId: this.socketId
      }).then(res => {
        this.code_url = undefined;
        this.code_url = res.data.d.code_url;
      });
    }
  },
  watch: {
    type(val) {
      this.handleResetTimer();
    }
  }
};
</script>

<style lang="scss" scoped>
.buyMemberLayout {
  background: rgba(0, 0, 0, 0.5);
  z-index: 2;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .coverBox {
    padding: 66px 63px 107px 62px;
    border-radius: 16px;
    width: 731px;
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/prcd_bg.png") no-repeat;
    background-size: 361px 404px;
    background-position: right bottom;
    // background-size: 100%;
    background-color: #fff;
    box-sizing: border-box;
    position: relative;
    // .cover_tl {
    //   background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/cover_tl.png") no-repeat;
    //   background-size: cover;
    //   width: 85px;
    //   height: 50px;
    //   display: inline-block;
    //   position: absolute;
    //   left: 0;
    //   top: 0;
    // }
    // .cover_rb {
    //   background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/cover_rb.png") no-repeat;
    //   background-size: cover;
    //   width: 103px;
    //   height: 67px;
    //   display: inline-block;
    //   position: absolute;
    //   right: 0;
    //   bottom: 0;
    // }
    .coverTitle {
      text-align: center;
      font-size: 22px;
      color: #653e12;
      // margin-bottom: 57px;

      &::before {
        content: "";
        width: 88px;
        height: 1px;
        background: #d3af76;
        display: inline-block;
        vertical-align: middle;
        margin-right: 25px;
      }
      &::after {
        content: "";
        width: 88px;
        height: 1px;
        background: #d3af76;
        display: inline-block;
        vertical-align: middle;
        margin-left: 25px;
      }
    }
    .coverSubTitle {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #6e6e6e;
      text-align: center;
      margin-top: 20px;
      margin-bottom: 30px;
    }
    .coverContent {
      .options {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .option {
          width: 112px;
          text-align: center;
          font-size: 16px;
          color: #b39164;
          display: flex;
          flex-direction: column;
          align-items: center;
          .pic {
            width: 93px;
            height: 107px;
            margin-bottom: 20px;
          }
          .prcd1 {
            background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/prcd1.png") no-repeat;
            background-size: cover;
          }
          .prcd2 {
            background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/prcd2.png") no-repeat;
            background-size: cover;
          }
          .prcd3 {
            background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/prcd3.png") no-repeat;
            background-size: cover;
          }
          .prcd4 {
            background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/prcd4.png") no-repeat;
            background-size: cover;
          }
        }
      }
      .payInfo {
        display: flex;
        margin-top: 87px;
        color: #6e6e6e;
        .payRight {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          line-height: 26px;
          .scanTip {
            display: flex;
            align-items: center;
            margin-right: 12px;
            font-size: 16px;
            // margin-bottom: 20px;
            margin-bottom: 5px;
            .ico_wechat {
              background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/ico_wechat.png") no-repeat;
              background-size: cover;
              display: inline-block;
              width: 20px;
              height: 20px;
              margin-right: 12px;
            }
          }
          .yfText {
            font-size: 18px;
            margin-bottom: 15px;
            margin-top: 15px;
          }
          .money {
            font-size: 32px;
            color: #ff5129;
          }
          .qrtimeValid {
            // margin-bottom: 10px;
            .qrTimer {
              color: #ff5129;
            }
          }
          .refreshTip {
            .refresh {
              color: #47a2ff;
              cursor: pointer;
            }
          }
        }
        .qrcode {
          width: 210px;
          height: 210px;
          //   background: #000;
          margin-right: 37px;
        }
      }
    }
    .icon_close {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/ico_close.png") no-repeat;
      background-size: cover;
      display: inline-block;
      width: 14px;
      height: 14px;
      position: absolute;
      right: 20px;
      top: 21px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BuyMember.vue